import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ContentMaster, ContentCategory, Content } from 'src/app/models/content';
import { User } from 'src/app/models/user';
import { CommonService } from 'src/app/services/common.service';
import { ContentService } from 'src/app/services/content.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-content-add',
  templateUrl: './content-add.component.html',
  styleUrls: ['./content-add.component.css']
})
export class ContentAddComponent implements OnInit {

  constructor(
    private contentService: ContentService,
    private userService: UserService,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) { 
    this.masterId = this.route.snapshot.params['masterId']
  }

  masterId: string
  contentMaster: ContentMaster = new ContentMaster()
  contentCategoryList: ContentCategory[]
  content: Content = new Content()
  ngOnInit(): void {
    this.content.isOpen = true
    this.content.contentCategoryNo = 0
    this.content.contentMasterId = this.masterId
    this.content.status = this.content.isOpen ? 'ON' : 'OF'
    this.getUserInfo()
    this.contentService.getCategoryList(this.masterId).subscribe(res => {
      this.contentMaster = res.data.contentMaster
      this.contentCategoryList = res.data.contentCategoryList
    })
  }
  loginedUser: User = new User()
  getUserInfo() {
    let loginedUserNo = this.commonService.getUserInfo().userNo
    this.userService.getUserInfo(loginedUserNo).subscribe(res => {
      this.loginedUser = res.data.user
    })
  }


  //screenshotFile: File    // 스크린샷
  //screenshotFileName: string  
  attachFileList: File[] = new Array()
  onAttachFileChange(files: FileList, event: any) {
    if(this.attachFileList.length > 4) {
      return alert("첨부파일은 5개까지만 가능합니다.")
    }
    if (files && files.length > 0) {
      this.attachFileList.push(files[0])
    }
  }
  deleteAttachFile(item: File) {
    let index = this.attachFileList.indexOf(item);
    this.attachFileList.splice(index, 1)
  }

  addContent() {
    if(this.content.contentCategoryNo == 0) {
      return alert('카테고리를 선택해 주세요')
    }
    if(!this.content.title || this.content.title == '') {
      return alert('제목을 입력해 주세요')
    }
    if(!this.content.description || this.content.description == '') {
      return alert('내용을 입력해 주세요')
    }
    const formData = new FormData();
    formData.append('metaData', new Blob([JSON.stringify(this.content)], { type: "application/json" }))
    this.attachFileList.forEach((f, idx) => {
      formData.append("files", f, f.name);
    })
    this.spinner.show()
    this.contentService.addContent(formData).subscribe(res => {
      this.spinner.hide()
      alert("정상적으로 등록 되었습니다.")
      window.opener.location.reload()
      this.windowClose()
    })
  }

  windowClose() {
    window.close()
  }
}
